import { Colors, ColorSolid, getFullValue } from "~/components/common/dashboard/RoadOffsetFormatterUtils";

const customChart = ({ data }) => {
    const [item] = data;
    const { DistanciaUrbanoPorcentagem, DistanciaUrbano, DistanciaRodoviarioPorcentagem, DistanciaRodoviario } = item;

    const DistanciaRodoviárioPorcentagem = DistanciaRodoviarioPorcentagem;

    const payload = Object.entries({
        DistanciaUrbanoPorcentagem,
        DistanciaRodoviárioPorcentagem,
    }).map((time) => ({
        name: time[0].substring(9, time[0].length - 11),
        value: time[1],
        fullValue: getFullValue(time[0].substring(9, time[0].length - 11), { DistanciaUrbano, DistanciaRodoviario }),
        itemStyle: {
            color: Colors(time[0].substring(9, time[0].length - 11)),
        },
        label: {
            color: ColorSolid(time[0].substring(9, time[0].length - 11)),
        },
    }));

    return payload;
};

export default { customChart };
